import ActionTypes from "redux/ActionTypes";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { catchError, setData } from "./main";
import { toggleModal } from "./modal";
import { getExchangeToken } from "./user";

export const setDataExchange = (key, data) => ({
    type: ActionTypes.SET_DATA_EXCHANGE,
    payload: {
        key,
        data,
    },
});

export const getStore = () => {
    return dispatch => {
        trackPromise(
            axios
                .get('api/store/')
                .then((resp) => {
                    dispatch(setDataExchange('itemList', resp.data.item_list));
                    dispatch(setDataExchange('fetchExchange', false));
                }).catch((err) => {
                    dispatch(catchError(err));
                })
        )
    }
}

export const buy = ({ id }) => {
    return dispatch => {
        dispatch(toggleModal('ModalConfirm'));
        trackPromise(
            axios
                .post('api/store/', { id })
                .then((resp) => {
                    dispatch(getStore());
                    dispatch(getExchangeToken());
                    dispatch(setData('prize', {...resp.data, id}));
                    dispatch(toggleModal('ModalPrize', true));
                    /** Reset */
                    dispatch(setData('fetchHistories', true));
                    dispatch(setDataExchange('fetchExchange', true));
                }).catch((err) => {
                    dispatch(catchError(err));
                })
        )
    }
}